import { z } from 'zod';

export const AdminStatsSchema = z.object({
  entities: z.number().int().min(0),
  activeUsers: z.number().int().min(0),
  openReferrals: z.number().int().min(0),
  auditEventsLast24h: z.number().int().min(0),
});

export type AdminStats = z.infer<typeof AdminStatsSchema>;
